
import axios from 'axios'


function getSpecs(query) {
    return axios.get(`${process.env.VUE_APP_APIURL}/bearingSpesifications`/*0 => verison code */, { params: query })
        .then(res => {
            return res.data
        })
}

export default {
    getSpecs
};